import request from '@/utils/request'
import { INTERFACE_SPLITS } from '@/constants/module/interface'

export function getList(query) {
  return request({
    url: '/admin/v1/drivers',
    method: 'get',
    params: query
  })
}
/**
 * @description: 获取司机详情
 * @param {*} id 司机id
 * @param {*} params 请求参数
 * @param {*} type 查看、编辑接口进行拆分，目的是对信息进行脱敏操作 枚举值为view、edit
 * @return {*}
 */
export function driverDetail(id, params, type = 'view') {
  if (type === 'view') {
    return request({
      url: `${INTERFACE_SPLITS.DRIVER_DETAIL[type]}/${id}`,
      method: 'get',
      params: params
    })
  } else {
    return request({
      url: `${INTERFACE_SPLITS.DRIVER_DETAIL[type]}`,
      method: 'get',
      params: { driver_id: id, ...params }
    })
  }
}
export function driverUpdate(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}`,
    method: 'put',
    data: data
  })
}
export function netUpdate(id, data) {
  return request({
    url: `/admin/v1/update_driver_net_info/${id}`,
    method: 'put',
    data: data
  })
}
export function peopCar(data) {
  return request({
    url: '/admin/v1/unbind_record',
    method: 'post',
    data: data
  })
}
export function carToCar(data) {
  return request({
    url: '/admin/v1/drivers/joining',
    method: 'post',
    data: data
  })
}
// 审核
export function check(data) {
  return request({
    url: '/admin/v1/drivers/review',
    method: 'post',
    data: data
  })
}
// 更换租赁公司
export function changeCompany(driverid, companyId, data) {
  return request({
    url: `/admin/v1/drivers/${driverid}/company/${companyId}`,
    method: 'patch',
    data
  })
}
// 批量更换租赁公司
export function changeAllCompany(data) {
  return request({
    url: `/admin/v1/company/patch`,
    method: 'patch',
    data: data
  })
}
// 接单设置查询
export function receiveModel(id) {
  return request({
    url: `/admin/v1/drivers/${id}/receipt`,
    method: 'get'
  })
}
// 接单设置更新
export function receiveModelUpdate(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/receipt`,
    method: 'patch',
    data: data
  })
}
// 批量接单设置
export function batchOrderSet(data) {
  return request({
    url: '/admin/v1/tasks/batch/receipt',
    method: 'patch',
    data
  })
}
// 批量上下线
export function batchLineSet(str, data) {
  return request({
    url: `/admin/v1/tasks/batch/status/${str}`,
    method: 'patch',
    data
  })
}
// 司机快速生生成账号
export function driverFastRegister(data) {
  return request({
    url: `/admin/v1/tasks/batch/register/fast`,
    method: 'patch',
    data
  })
}
// 批量终审
export function allReview(data) {
  return request({
    url: '/admin/v1/drivers/review/batch',
    method: 'post',
    data
  })
}
// 三方校验查询
export function otherCheck(id) {
  return request({
    url: `/admin/v1/drivers/${id}/licenseValidate?agent=dcms`,
    method: 'get'
  })
}
// 三方校验更新
export function otherCheckUpdate(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/licenseValidate`,
    method: 'patch',
    data: data
  })
}
// 更新网约人证
export function netPeopleUpdate(id, data) {
  return request({
    url: `/admin/v1/update_net_driver_info/${id}`,
    method: 'put',
    data: data
  })
}
// 更新网约车证
export function netCarUpdate(id, data) {
  return request({
    url: `/admin/v1/update_net_car_info/${id}`,
    method: 'put',
    data: data
  })
}
// 上下线操作
export function driverLineType(id, status, data) {
  return request({
    url: `/admin/v1/drivers/${id}/status/${status}`,
    method: 'patch',
    data
  })
}
// 批量操作记录
export function batchRecord(params) {
  return request({
    url: '/admin/v1/batch/tasks',
    method: 'get',
    params
  })
}
// 变更司机信息
export function changeDriverInfo(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/change_driver_info`,
    method: 'patch',
    data
  })
}
// 变更车辆信息
export function changeCarInfo(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/change_car_info`,
    method: 'patch',
    data
  })
}
// 变更网约人证信息
export function changeNetInfo(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/change_net_driver_info`,
    method: 'patch',
    data
  })
}
// 变更网约车证信息
export function changeNetCarInfo(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/change_net_car_info`,
    method: 'patch',
    data
  })
}
// 变更保险信息
export function changeInsureInfo(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/change_insurance_info`,
    method: 'patch',
    data
  })
}
// 5个审核状态拆分
export function reviewDriver(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/review/driver`,
    method: 'patch',
    data
  })
}
export function reviewCar(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/review/car`,
    method: 'patch',
    data
  })
}
export function reviewNetDriver(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/review/driver/net`,
    method: 'patch',
    data
  })
}
export function reviewNetCar(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/review/car/net`,
    method: 'patch',
    data
  })
}
export function reviewInsure(id, data) {
  return request({
    url: `/admin/v1/drivers/${id}/review/insurance`,
    method: 'patch',
    data
  })
}
// 根据城市id获取是否需要网约信息
export function getCitySet(id) {
  return request({
    url: `/admin/v1/config/network/${id}`,
    method: 'get'
  })
}

// 查询司机真实轨迹
export function getDriverRealPoints(data) {
  return request({
    url: `/admin/v1/drivers/get_driver_real_points`,
    method: 'post',
    data: data
  })
}

// 查询司机归档轨迹（清洗后）
export function getDriverArchivePoints(data) {
  return request({
    url: `/admin/v1/drivers/get_driver_archive_points`,
    method: 'post',
    data: data
  })
}

// 查询司机即时订单列表
export function getDriverRealOrderList(data) {
  return request({
    url: `/admin/v1/drivers/get_driver_real_order_list`,
    method: 'post',
    data: data
  })
}

// 查询司机订单列表
export function getDriverAllOrderList(data) {
  return request({
    url: `/admin/v1/drivers/get_driver_order_list`,
    method: 'post',
    data: data
  })
}
// 司机代注册
export function RegList(params) {
  return request({
    url: '/admin/v1/tasks/batch/register/drivers',
    method: 'get',
    params
  })
}
export function driverReg(data) {
  return request({
    url: '/admin/v1/tasks/batch/register/drivers',
    method: 'post',
    data
  })
}
export function AddDriverCarLabel(data) { // 添加司机-车辆标签
  return request({
    url: '/admin/v1/label/driverOrCar/add',
    method: 'patch',
    data
  })
}

export function AddDriverCarLabelRadio(id, data) { // 添加司机-车辆标签-单个
  return request({
    url: `/admin/v1/label/driverOrCar/add/${id}`,
    method: 'patch',
    data
  })
}
export function RemoveDriverCarLabel(data) { // 移除司机-车辆标签
  return request({
    url: '/admin/v1/label/driverOrCar/remove',
    method: 'patch',
    data
  })
}

// 出行系统
// 司机列表
export function driverList(query) {
  return request({
    url: '/admin/v1/thirdTransport/driver/list',
    method: 'get',
    params: query
  })
}
// 司机详情
export function driverInfo(query) {
  return request({
    url: '/admin/v1/thirdTransport/driver/info',
    method: 'get',
    params: query
  })
}
// 车辆列表
export function carList(query) {
  return request({
    url: '/admin/v1/thirdTransport/car/list',
    method: 'get',
    params: query
  })
}
// 车辆详情
export function carInfo(query) {
  return request({
    url: '/admin/v1/thirdTransport/car/info',
    method: 'get',
    params: query
  })
}
// 查询司机标签
export function getDriverCarLabels(params) {
  return request({
    url: '/admin/v1/label/getDriverCarLabels',
    method: 'get',
    params
  })
}

// 查询司机标签
export function delDriverCarLabels(data) {
  return request({
    url: '/admin/v1/label/delDriverCarLabels',
    method: 'post',
    data: data
  })
}


// 双班司机检查
export function doubleDriver(params) {
  return request({
    url: '/admin/v1/register/check/double_driver',
    method: 'get',
    params
  })
}

// 添加黑名单
export function addBlack(data) {
  return request({
    url: '/admin/v1/blacklist/add',
    method: 'post',
    data: data
  })
}
// 获取司机安全字段
export function getDriverSensitiveInfo(driver_id,type,reason = '查询信息') {
  return request({
    url: `/admin/v1/drivers/${driver_id}/sensitive/info`,
    method: 'get',
    params: {
      driver_id: driver_id,
      type: type,
      reason: reason
    }
  })
}

// 信息处理接口
export function thirdTransportInfoPdfDownload(params){
  return request({
    url: '/admin/v1/thirdTransport/info/pdf_download',
    method: 'POST',
    data: params
  })
}

/**
 * 新标签系统
 * */
// 单个添加标签
export function addDriverLabel(params){
  return request({
    url: `/admin/dcms/v1/label/operate/label_add`,
    method: 'POST',
    data:params
  })
}
// 批量添加标签
export function batchAddDriverLabel(params){
  return request({
    url: `/admin/dcms/v1/label/operate/label_add_batch`,
    method: 'POST',
    data:params
  })
}
// 单个移除标签
export function removeDriverLabel(params){
  return request({
    url: `/admin/dcms/v1/label/operate/labels_remove`,
    method: 'POST',
    data:params
  })
}
// 批量移除标签
export function batchRemoveDriverLabel(params){
  return request({
    url: `/admin/dcms/v1/label/operate/label_remove_batch`,
    method: 'POST',
    data:params
  })
}
// 获取司机标签
export function getDriverLabel(params){
  return request({
    url: `/admin/dcms/v1/label/operate/driver_labels`,
    method: 'GET',
    params
  })
}

/**
 * 获取查询标签
 * @param {*} params
 * @param {*} params.strategy_filter 是否过滤添加标签和禁用策略
 * @returns
 */
export function getDriverAndCarLabel(params){
  return request({
    url: `/admin/dcms/v1/label/operate/base_select_search`,
    method: 'GET',
    params
  })
}

/**
 * @description: 信息变更提交-身份证信息
 * @param {*} data
 * @return {*}
 */
export function driverIdCardApply(data){
  return request({
    url: '/admin/dcms/v1/changes/driver_id_card_apply',
    method: 'POST',
    data
  })
}
/**
 * @description: 信息变更提交-驾驶证信息
 * @param {*} data
 * @return {*}
 */
export function driverLicApply(data){
  return request({
    url: '/admin/dcms/v1/changes/driver_lic_apply',
    method: 'POST',
    data
  })
}
/**
 * @description: 信息变更提交-车辆信息
 * @param {*} data
 * @return {*}
 */
export function carLicApply(data){
  return request({
    url: '/admin/dcms/v1/changes/car_lic_apply',
    method: 'POST',
    data
  })
}
/**
 * @description: 信息变更提交-人证
 * @param {*} data
 * @return {*}
 */
export function driverNetLicApply(data){
  return request({
    url: '/admin/dcms/v1/changes/driver_net_lic_apply',
    method: 'POST',
    data
  })
}
/**
 * @description: 信息变更提交-车证
 * @param {*} data
 * @return {*}
 */
export function carNetLicApply(data){
  return request({
    url: '/admin/dcms/v1/changes/car_net_lic_apply',
    method: 'POST',
    data
  })
}
/**
 * @description: 信息变更提交-保险
 * @param {*} data
 * @return {*}
 */
export function driverInsuranceApply(data){
  return request({
    url: '/admin/dcms/v1/changes/driver_insurance_apply',
    method: 'POST',
    data
  })
}
/**
 * @description: 根据司机ID查询司机状态（是否已注销）
 * @param {Number} params.driver_id 司机id
 * @return {*}
 */
export function getDriverLogoffStatus(params)  {
  return request({
    url: '/admin/dcms/v1/driver/logoff_status',
    method: 'GET',
    params
  })
}

/**
 * 批量解绑数据保存
 * @param {*} data
 * @param { String } data.excel_url  文件url
 * @return {*}
 */

export function handleBatchUnbind(data) {
  return request({
    url: '/resource/dcms/v1/driver/batch_unbind',
    method: 'POST',
    data
  })
}
